import { Fragment } from "react";
import { Outlet } from "react-router-dom";
import { Alert } from "react-bootstrap";
import classes from "./Layout.module.css";
import MainNavigation from "./MainNavigation";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga";

ReactGA.initialize(process.env.REACT_APP_ANALYTICSKEY, {
  debug: false,
});

const Layout = (props) => {
  const location = useLocation();
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, [location]);

  return (
    <Fragment>
      <MainNavigation />
      <Alert variant="warning" className="mb-0 py-2 rounded-0 text-center small">
        This website is no longer updated. Data are still provided regularly
        at{" "}
        <Alert.Link href="https://jabrell.github.io/euetsinfo/">
          jabrell.github.io/euetsinfo
        </Alert.Link>
        . Visualizations are now available at{" "}
        <Alert.Link href="https://ets.bruegel.org/">ets.bruegel.org</Alert.Link>.
      </Alert>
      <div className={classes.main}>
        <Outlet />
      </div>
    </Fragment>
  );
};

export default Layout;
